import React from 'react'
import "./AboutUsContent.css"

export default function AboutUSContent() {
    return (
        <section className='about-us-content'>
            <div className='container'>
                <div className='row maindiv'>
                    <div className='heading col-md-3'>
                        <h2>About Us</h2>
                        <p>Read The Story Behind Our Success</p>
                    </div>
                    <div className='content col'>
                        <p className='mt-0'>We provide buy-side, sell-side and market infrastructure firms with a full-service offering, including systems integration & technology consulting services, to assist in delivering high performance trading and settlement </p>
                        <p className='mb-0'>More than 25 years of experience working in the industry has enabled us to build our services and solutions in strategy, consulting, digital, technology & operations that help our clients with their trading projects around the world. Capabilities we leverage.</p>
                    </div>

                </div>
            </div>

        </section>
    )
}
